/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Byodformularerhalten2Inputs */

const de__field_byodformularerhalten2 = /** @type {(inputs: _Field_Byodformularerhalten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYOD Formular erhalten`)
};

/**

* @param {_Field_Byodformularerhalten2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_byodformularerhalten2 = /** @type {((inputs?: _Field_Byodformularerhalten2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Byodformularerhalten2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_byodformularerhalten2(inputs)
});
export { _field_byodformularerhalten2 as "_field_byodFormularErhalten" }